import React, { PureComponent } from 'react';

import PageTitle from '../../components/PageTitle';
import FeaturesComparison from '../../components/FeaturesComparison';

import { packageSectionsTransform } from './utils';
import defaultSettings from './settings';
import userSettings from './userSettings';
import {
    COMPARE_PACKAGE_CTA_ACTION,
    GA_P1_LABEL,
    GA_P2_LABEL,
    GA_P3_LABEL,
} from '../../constants/analytics';
import { PACKAGE_COMPARISON_PAGE } from '../../constants/main';
import { handleLoadDriftChatbot, loadCrazyEgg } from '../utils';

export default class PackageComparisonPage extends PureComponent {
    componentDidMount() {
        const { isAuthenticated, tld } = this.props;

        handleLoadDriftChatbot(tld, isAuthenticated);

        loadCrazyEgg();
    }

    render() {
        const {
            locale,
            isAuthenticated,
            feeBreakdown,
            assortmentsTax,
            selectedPackage,
            clearSelectedPackage,
            redirectToEssentials,
            redirectToProfessional,
            redirectToPremium,
            userPlan,
            packageTitles,
            cappedFeeExperimentFeatureFlag,
            assortmentsAvailability,
        } = this.props;
        const { current: { version: packageVersion } = {} } =
            assortmentsAvailability || {};

        const {
            primaryHeading,
            paymentProcessingFeature,
            sections,
            CTAs,
            CTAStyles,
            pricePerFreeTicket,
            showMaxFee,
        } = packageSectionsTransform({
            locale,
            isAuthenticated,
            userPlan,
            packageVersion,
            defaultSettings,
            page: PACKAGE_COMPARISON_PAGE,
            userSettings,
        });

        const getStartedActions = [
            redirectToEssentials.bind(
                null,
                COMPARE_PACKAGE_CTA_ACTION,
                GA_P1_LABEL,
            ),
            redirectToProfessional.bind(
                null,
                COMPARE_PACKAGE_CTA_ACTION,
                GA_P2_LABEL,
            ),
            redirectToPremium.bind(
                null,
                COMPARE_PACKAGE_CTA_ACTION,
                GA_P3_LABEL,
            ),
        ];

        return (
            <div className="eds-bg-color--white">
                <PageTitle title={packageTitles.comparePackages} />
                <FeaturesComparison
                    locale={locale}
                    feeBreakdown={feeBreakdown}
                    assortmentsTax={assortmentsTax}
                    primaryHeading={primaryHeading}
                    paymentProcessingFeature={paymentProcessingFeature}
                    sections={sections}
                    selectedPackage={selectedPackage}
                    getStartedActions={getStartedActions}
                    clearSelectedPackage={clearSelectedPackage}
                    showMaxFee={showMaxFee}
                    CTAs={CTAs}
                    CTAStyles={CTAStyles}
                    pricePerFreeTicket={pricePerFreeTicket}
                    shouldShowCappedFee={cappedFeeExperimentFeatureFlag}
                />
            </div>
        );
    }
}
